import { createBrowserHistory } from 'history';
import PortalIdParser from 'PortalIdParser';
export const history = createBrowserHistory({
  basename: `/settings/${PortalIdParser.get()}/user-preferences/tasks`
});